/*
 * @Author: sunhui04
 * @Date: 2021-07-21 17:19:06
 */
function canIUse(apiName) {
    // APP（极简版等）支持的api由window.__MT_supportAPIS注入
    // 不直接使用baseApis，避免大数组的循环
    var webMatchNativeNames = [
        {
        name: 'closeWebview',
        message: 'closeWindow'
        },
        {
        name: 'getCity',
        message: 'getCityInfo',
        },
        {
        name: 'openPage',
        message: 'openScheme',
        },
        {
        name: 'jumpPage',
        message: 'jumpToScheme',
        },
        {
        name: 'closePage',
        message: 'closeWindow',
        },
        {
        name: 'uploadImage',
        message: 'uploadPhoto',
        }
    ]

    webMatchNativeNames.forEach(function(item) {
        if(item.name === apiName){
            apiName = item.message;
            return;
        }
    })
    if(window.__MT_supportAPIS 
        && Array.isArray(window.__MT_supportAPIS)
        && (window.__MT_supportAPIS.indexOf(apiName) === -1)) {
        return false;
    } else {
        return true;
    }
}

module.exports = canIUse;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/common/canIUse.js
// module id = 509
// module chunks = 0